import * as React from 'react';
import { Icon, Tooltip } from '../../primitives';
import { namespacedClassnames } from '../../common';
import { Button, LibColor, Label, Text } from '../../new-libby';
import { compKey } from './key';
import { readIcon } from './read_icon';
export var NotificationItem = function (props) {
    var renderLabel = function (labelText) { return (React.createElement(Label, { className: 'urgent-label', borderColor: LibColor.red120, color: LibColor.red140, size: 'tiny' },
        React.createElement(Text, { type: 'ts' }, labelText))); };
    return (React.createElement("div", { className: namespacedClassnames(compKey, props.isRead ? 'read' : 'unread', { 'has-action': !!props.onClick }), onClick: props.onClick },
        React.createElement("div", { className: 'notification-content-wrapper' },
            React.createElement("div", { className: 'icon-container' }, props.icon),
            React.createElement("div", { className: 'content' },
                React.createElement(Text, { className: 'title' },
                    props.labelText ? renderLabel(props.labelText) : null,
                    props.title),
                React.createElement(Text, { className: 'description', color: 't40', type: 'ts' }, props.description)),
            React.createElement("div", { className: 'action-container' },
                React.createElement("div", { className: 'action' },
                    React.createElement(Tooltip, { className: 'read-tooltip', body: props.readTooltipBody },
                        React.createElement(Button, { className: 'toggle-read-button', onClick: props.onToggleRead, type: 'tertiary' },
                            React.createElement(Icon, { className: 'read-icon', icon: readIcon }))),
                    props.actionIcon)))));
};
//# sourceMappingURL=index.js.map